/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'screen_run': {
    width: 16,
    height: 16,
    viewBox: '0 0 36.88 41',
    data: '<g data-name="图层 2"><g data-name="图层 1"><path pid="0" _fill="none" _stroke="#383e47" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.11 39.25H1V1h32.9v23.27M21.59 29.82a7.27 7.27 0 0113.6 1M35.88 28.92l-.69 1.89M34.79 35.74a7.27 7.27 0 01-13.6-1M20.5 36.64l.69-1.89M29.83 32.9h-4.69"/><path pid="1" _fill="#df4545" d="M33.02 32.9l-4.25-3.42v6.83l4.25-3.41z"/><path pid="2" _fill="none" _stroke="#383e47" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7.41 20.12l6.29-8.85 6.12 7.11 6.69-9.44"/></g></g>'
  }
})
